import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllStudents, deleteStudent } from "../server/institutionAllApi";
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const StudentList = () => {
  const [students, setStudents] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [token, setToken] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [verifiedStudents, setVerifiedStudents] = useState({});
  const [completedStudents, setCompletedStudents] = useState({});
  const [roleName, setRoleName] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const batchwiseStudent = location.state?.batch._id;

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    const userEmail = parsedUser?.userName;
    setUserName(userEmail);
    setRoleName(role);
    // console.log(batchwiseStudent);
    setToken(storedToken);
  }, []);

    useEffect(() => {
    if (!token) return;
  
    const fetchData = async () => {
      // Admin sees all students
      if (roleName === "Admin") {
        await fetchStudents();
      }
      else if (roleName === "Tutor" && batchwiseStudent) {
        await fetchStudentsByBatch();
      }
      // Tutor with E2TMT0001 and batch view
      else if (roleName === "Tutor" && userName === "E2TMT0001") {
        await fetchStudents();
      }
      // else if (roleName === "Tutor" && userName === "E2TMT0001" && batchwiseStudent) {
      //   await fetchStudentsByBatch();
      // }
      // Other Tutors with batch view
      // else if (roleName === "Tutor" && batchwiseStudent) {
      //   await fetchStudentsByBatch();
      // }
      // Regular Tutor view
      else if (roleName === "Tutor") {
        await fetchStudentsbyTaughtByTutor();
      }
      // Default case
      else {
        await fetchStudents();
      }
  
      // Fetch additional data needed for all cases
      await fetchdepartment();
      await fetchBatches();
    };
  
    fetchData();
  }, [
    token,
    currentPage,
    roleName,
    itemsPerPage,
    searchTerm,
    batchwiseStudent,
    selectedBatch,
    selectedDepartment,
    selectedCourseCategory,
    selectedCourse,
    userName // Added userName to dependencies
  ]);

  useEffect(() => {
    fetchCourseCategories();
  }, [selectedDepartment]);

  useEffect(() => {
    if (!selectedBatch) {
      setSelectedBatch("");
      return;
    }

    fetchStudentsByBatch();
  }, [selectedBatch]);

  const fetchStudentsByBatch = async () => {
    try {
      setLoading(true);
      const studentsResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-students-batch?&batch=${batchwiseStudent}`,
        {
          params: {
            page: currentPage, // Incrementing to match API pagination logic
            limit: itemsPerPage,
            search: searchTerm,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      /////////////////////////////////////////////////////////////
      // Handle students data

      if (studentsResponse) {
        //
        setStudents(studentsResponse?.data?.data);
        setTotalItems(studentsResponse?.data?.pagination?.totalItems); // Assuming your API returns this
        setTotalPages(studentsResponse?.data?.pagination?.totalPages);
        setVerifiedStudents(
          studentsResponse.data.data.reduce((acc, student) => {
            acc[student._id] = student.verificationStatus === "verified";
            return acc;
          }, {})
        );
        setCompletedStudents(
          studentsResponse.data.data.reduce((acc, student) => {
            acc[student._id] = student.completionStatus === "completed";
            return acc;
          }, {})
        );
        // // console.log("Students fetched successfully:", studentsData);
      } else {
        // console.log("No students found.");
      }
    } catch (error) {
      console.error("Failed to fetch students:", error);
    } finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDepartment || !selectedCourseCategory) {
      return;
    }
    fetchCourse();
  }, [selectedDepartment, selectedCourseCategory]);

  const fetchBatches = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBatches(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      console.error("Failed to fetch students:", error);
    }
  };

  const fetchCourse = async () => {
    if (!selectedCourseCategory) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${selectedDepartment}/${selectedCourseCategory}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCourses(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCourseCategories = async () => {
    // Check if selectedDepartment is available before making the request
    if (!selectedDepartment) {
      // console.log("Department not selected.");
      return;
    }

    // Ensure we have a valid token
    if (!token) {
      // console.log("Access required: No token provided.");
      return;
    }

    try {
      // Fetch course categories
      const courseCategoriesResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Handle the course categories data
      const courseCategoriesData = courseCategoriesResponse.data?.data;
      if (courseCategoriesData) {
        setCourseCategories(courseCategoriesData);
        // console.log(
        //   "Course categories fetched successfully:",
        //   courseCategoriesData
        // );
      } else {
        // console.log("No course categories found.");
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const fetchdepartment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStudentsbyTaughtByTutor = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-students-taught-by-tutor?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&batch=${selectedBatch}&department=${selectedDepartment}&level=${selectedCourseCategory}&course=${selectedCourse}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setStudents(response.data.data);
      setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch students:", error);
      setError("Failed to fetch students.");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-students?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&batch=${selectedBatch}&department=${selectedDepartment}&level=${selectedCourseCategory}&course=${selectedCourse}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setStudents(response.data.data);
      setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch students:", error);
      setError("Failed to fetch students.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleEditStudent = (student) => {
    navigate("/view-student", { state: { student } });
    // console.log("student deatails:  ", student);
  };

  const handleDeleteStudent = async (student) => {
    const reqHeader = { authorization: `Bearer ${token}` };
    try {
      const res = await deleteStudent(student._id, reqHeader);
      if (res.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        if (roleName === "Admin"){
          fetchStudents();
        }else if (roleName === "Tutor" && batchwiseStudent) {
          fetchStudentsByBatch();
        } else if (roleName === "Tutor") {
          fetchStudentsbyTaughtByTutor();
        }
      } else {
        alert(res.err);
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleShowDeleteModal = (student) => {
    setSelectedStudent(student);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedStudent(null);
  };

  const confirmDelete = async () => {
    if (selectedStudent) {
      await handleDeleteStudent(selectedStudent);
      handleCloseDeleteModal();
    }
  };

  const handleDeleteClick = (student) => {
    setStudentToDelete(student);
    setShowDeleteModal(true);
  };

  const handleCloseModal = () => {
    setShowDeleteModal(false);
    setStudentToDelete(null);
  };

  const handleVerifyClick = async (studentId) => {
    // console.log("student data: ", studentId);
    
    try {
      // Update the verification status in the backend
      const newStatus = verifiedStudents[studentId]
        ? "notverified"
        : "verified";

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-verification-status/${studentId}`,
        { verificationStatus: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        // Successfully updated, update the local state to reflect the change
        setVerifiedStudents((prevState) => ({
          ...prevState,
          [studentId]: true,
        }));
      }
    } catch (error) {
      console.error("Error updating verification status:", error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeleteStudent(studentToDelete);
      handleCloseModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}/${month}/${day}`;
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleToggleStatus = async (item) => {
    try {
      const updatedStatus = !item.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/student-status-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        setStudents((prevtrader) =>
          prevtrader.map((b) =>
            b._id === item._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle student status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {/* {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )} */}
      <div
        className="card-content"
        //  style={styles.cardContent(loading)}
      >
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <form
              className="search px-10"
              style={{
                border: "1px solid #6b7280",
                display: "flex",
                alignItems: "center",
                borderRadius: "10px",
              }}
              onSubmit={(e) => e.preventDefault()}
            >
              <Icon
                icon="ion:search-outline"
                className="icon"
                style={{ marginRight: "10px" }}
              />
              <input
                type="text"
                className="bg-base h-40-px"
                name="search"
                onChange={(e) => {
                  let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9@.-\s]/g, "").trimStart();

                setSearchTerm(value);
                  setCurrentPage(1); // Reset to the first page
                }}
                value={searchTerm}
                placeholder="Search"
              />
            </form>

            {/* Batches */}
            {!batchwiseStudent && (roleName === "Admin") && (
              <>
                <select
                  className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                  value={selectedBatch}
                  onChange={(e) => {
                    setSelectedBatch(e.target.value);
                    setSelectedDepartment("");
                    setSelectedCourseCategory("");
                    setSelectedCourse("");
                  }}
                >
                  <option value="">Select Batches</option>
                  {batches?.upcoming?.map((batch) => (
                    <option key={batch._id} value={batch._id}>
                      {batch.batch_name}
                    </option>
                  ))}
                </select>

                <select
                  className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                  value={selectedDepartment}
                  onChange={(e) => {
                    setSelectedDepartment(e.target.value);
                    setSelectedBatch("");
                    setSelectedCourseCategory("");
                    setSelectedCourse("");
                  }}
                >
                  <option value="">Select Departments</option>
                  {departments.length > 0 ? (
                    departments.map((department) => (
                      <option key={department?._id} value={department?._id}>
                        {department?.department_name}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No Options
                    </option>
                  )}
                </select>

                {selectedDepartment && (
                  <select
                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                    value={selectedCourseCategory}
                    onChange={(e) => {
                      setSelectedCourseCategory(e.target.value);
                      setSelectedCourse("");
                    }}
                  >
                    <option value="">Select Level</option>
                    {courseCategories.length > 0 ? (
                      courseCategories.map((level) => (
                        <option key={level?._id} value={level?._id}>
                          {level?.courseCategoryName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No Options
                      </option>
                    )}
                  </select>
                )}

                {selectedDepartment && selectedCourseCategory && (
                  <select
                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                  >
                    <option value="">Select Course</option>
                    {courses.length > 0 ? (
                      courses.map((course) => (
                        <option key={course?._id} value={course?._id}>
                          {course?.coursename}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No Options
                      </option>
                    )}
                  </select>
                )}
              </>
            )}
          </div>

         {roleName==="Admin" && <Link
            to="/student-create"
            className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
          >
            <Icon
              icon="ic:baseline-plus"
              className="icon text-xl line-height-1"
            />
            Add New
          </Link>}
        </div>
        <div className="card-body p-24">
          <div className="row gy-4">
            {students?.length > 0 ? (
              students?.map((student, index) => (
                <div className="col-xxl-3 col-md-6 user-grid-card">
                  <div className="position-relative border radius-16 overflow-hidden h-100 d-flex flex-column">
                    {roleName==="Admin" && <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                      <button
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="bg-white-gradient-light w-32-px h-32-px radius-8 border border-light-white d-flex justify-content-center align-items-center text-white"
                      >
                        <Icon
                          icon="entypo:dots-three-vertical"
                          className="icon "
                        />
                      </button>
                      <ul className="dropdown-menu p-12 border bg-base shadow">
                        <li>
                          <button
                            onClick={() => handleToggleStatus(student)}
                            className={`dropdown-item btn-reset text-secondary-light bg-hover-${
                              student.status ? "success" : "danger"
                            }-100 text-hover-${
                              student.status ? "success" : "danger"
                            }-600 d-flex align-items-center gap-10`}
                          >
                            <Icon
                              icon={
                                student.status
                                  ? "mdi:check-circle-outline"
                                  : "mdi:cancel"
                              }
                              className="icon text-lg line-height-1"
                            />
                            {student.status ? "Active" : "Inactive"}
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => handleDeleteClick(student)}
                            className="delete-item dropdown-item btn-reset text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="icon text-lg line-height-1"
                            />
                            Delete
                          </button>
                        </li>
                      </ul>
                    </div>}

                    <div className="ps-16 pb-16 pe-16 text-center mt-20 d-flex flex-column flex-grow-1">
                      {/* verify and complete buttons */}
                     

                      <div className="mb-3">
                        <img
                          src={
                            student.profile_url ||
                            "assets/images/user-grid/user-grid-img14.png"
                          }
                          alt=""
                          className="border br-white border-width-2-px w-100-px h-100-px rounded-circle object-fit-cover"
                        />
                        <h6 className="text-lg mb-0 mt-4">
                          {student?.name ?? "null"}
                        </h6>
                        <span className="text-secondary-light d-block mb-16">
                          {student?.email ?? "null"}
                        </span>
                      </div>

                      <div className="center-border position-relative bg-danger-gradient-light radius-8 p-12 d-flex align-items-stretch gap-4 mb-3">
                        <div className="text-center w-50 d-flex flex-column">
                          <h6
                            className="text-md mb-1"
                            style={{
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: "2",
                              WebkitBoxOrient: "vertical",
                              minHeight: "40px",
                            }}
                          >
                          {student?.department?.department_name || "----"}
                          </h6>
                          <span className="text-secondary-light text-sm">
                            Department
                          </span>
                        </div>
                        <div className="text-center w-50 d-flex flex-column">
                          <h6
                            className="text-md mb-1"
                            style={{
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: "2",
                              WebkitBoxOrient: "vertical",
                              minHeight: "40px",
                            }}
                          >
                            {student?.education ?? "----"}
                          </h6>
                          <span className="text-secondary-light text-sm">
                            Education
                          </span>
                        </div>
                      </div>

                      <div className="mt-auto d-flex flex-column gap-2">
                        <Link
                          to="/view-student"
                          state={{ student }}
                          className="bg-primary-50 text-primary-600 bg-hover-primary-600 hover-text-white p-10 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center justify-content-center fw-medium gap-2 w-100"
                        >
                          View Profile
                          <Icon
                            icon="solar:alt-arrow-right-linear"
                            className="icon text-xl line-height-1"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="d-flex justify-content-center w-100 text-center">
                No students found
              </p>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing{" "}
              {students.length === 0
                ? "0"
                : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
              to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
              {totalItems} entries
            </span>

            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              {/* Previous Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{
                    pointerEvents: currentPage === 1 ? "none" : "auto",
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-left" />
                </Link>
              </li>

              {/* Current Page Number */}
              <li className="page-item">
                <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                  {currentPage}
                </span>
              </li>

              {/* Next Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{
                    pointerEvents: currentPage === totalPages ? "none" : "auto",
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-right" />
                </Link>
              </li>

              {/* Modal Delete Event */}
              <Modal
                show={showDeleteModal}
                onHide={handleCloseModal}
                centered
                backdrop="static"
                size="sm"
              >
                <div className="modal-content radius-16 bg-base">
                  <div className="modal-body p-24 text-center">
                    <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                      <Icon
                        icon="fluent:delete-24-regular"
                        className="menu-icon"
                      />
                    </span>
                    <h6 className="text-lg fw-semibold text-primary-light mb-0">
                      Are you sure you want to delete this student?
                    </h6>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                      <button
                        type="button"
                        onClick={handleCloseModal}
                        className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={handleConfirmDelete}
                        className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
            </ul>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
// const styles = {
//   loaderContainer: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     zIndex: 1000,
//   },
//   cardContent: (loading) => ({
//     opacity: loading ? 0.5 : 1,
//   }),
// };

export default StudentList;
